import { render } from "./UserInfo.vue?vue&type=template&id=db8b6b10&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=db8b6b10&lang=scss&scoped=true"
import "./UserInfo.vue?vue&type=style&index=1&id=db8b6b10&lang=css"
script.render = render
script.__scopeId = "data-v-db8b6b10"

export default script